import QuestionCreator from '../questionCreator';
import TaskDetails from '../../../components/shared/TaskDetails';

import { IQuestionComponentProps } from '../types';

import imgFillingSurvey from '/images/filling-survey.svg';
import { HISTORY_TYPE } from '../../../constants';
import MESSAGES from '../../../constants/message';

const MedicalHistoryComponent: React.FC<IQuestionComponentProps> = ({
  isQuestionnaireComplete,
  questionnaires,
  toggleQuestionnaireCompletion,
  navigateToTasks,
}) => {
  if (isQuestionnaireComplete) {
    return (
      <TaskDetails
        title={MESSAGES.MEDICAL_HISTORY.TITLE}
        description={MESSAGES.MEDICAL_HISTORY.DESCRIPTION}
        buttonText={MESSAGES.MEDICAL_HISTORY.BUTTON_CONTINUE}
        imgSrc={imgFillingSurvey}
        imgAlt="filling-survey"
        imgWidth="287px"
        handleClick={toggleQuestionnaireCompletion}
        handleClose={navigateToTasks}
      />
    );
  }

  if (questionnaires)
    return (
      <QuestionCreator
        questionnaires={questionnaires}
        historyType={HISTORY_TYPE.MEDICAL}
      />
    );

  return null;
};

export default MedicalHistoryComponent;
